module.exports = __webpack_public_path__ + "fontawesome-webfont.1dc35d25e61d819a9c35.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-social/assets/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 687
// module chunks = 2